<template>
  <div class="footer">
    <div class="home">
      <div class="left_f fl">
        <div class="menu1">
          <a href="http://company.drcnet.com.cn/about.html" target="_blank">关于我们</a>|
          <a href="http://company.drcnet.com.cn/cpyc.html" target="_blank">诚聘英才</a>|
          <a href="http://misc.drcnet.com.cn/us/wangzsm.aspx" target="_blank">网站声明</a>|
          <a href="http://company.drcnet.com.cn/lxwm.html#/contact" target="_blank">联系我们</a>|
          <a
            href="javascript:void(0)"
            onclick="SetHome(this,&quot;http://www.drcnet.com.cn&quot;);"
          >设为首页</a>|
          <a
            href="http://misc.drcnet.com.cn/DRCNet.Users.Web/User/UserSuggestAdd1.aspx"
            target="_blank"
          >意见和建议</a>|
          <a href="mailto:chiefeditor@drcnet.com.cn">总监信箱</a>
        </div>
        <div class="tel">
          <img src="http://www.drcnet.com.cn/www/int/images/tel.png" class="fl" />
          <div class="hm fl">
            <span>热线电话：</span>
            <p>400-7070-678</p>
          </div>
          <div class="clear"></div>
        </div>
        <div class="footer_bottom">Copyright©1998-{{newYear}} DRCnet. All Rights Reserved&nbsp;版权所有 国研网</div>
      </div>
      <div class="right_f_wx fr">
        <ul class="ewm">
          <li>
            <img src="http://www.drcnet.com.cn/www/int/images/weixin.jpg" class="ewm1" />
            <p>服务号</p>
          </li>
          <li>
            <img src="http://www.drcnet.com.cn/www/int/images/jjzh.jpg" class="ewm1" />
            <p>订阅号</p>
          </li>
          <li>
            <img
              src="http://www.drcnet.com.cn/www/int/images/drcnet-app-andriod-qrcode.jpg"
              class="ewm1"
            />
            <p>安卓版</p>
          </li>
          <li>
            <img
              src="http://www.drcnet.com.cn/www/int/images/drcnet-app-ios-qrcode.jpg"
              class="ewm1"
            />
            <p>IOS版</p>
          </li>
        </ul>
      </div>
      <div class="clear"></div>
    </div>
    <div class="clear"></div>
    <div class="bottom-f">
      <div class="home">
        <ul class="bq">
          <li class="tips">
            <span class="fl"> <a class="ipc" href="https://beian.miit.gov.cn" target="_blank">京ICP证030059号</a>&nbsp;&nbsp;中关村信用促进会会员证书</span>
            <a
              href="http://www.hd315.gov.cn/beian/view.asp?bianhao=010202001050900196"
              target="_blank"
              class="fl"
            >
              <img src="http://www.drcnet.com.cn/www/int/images/beian.png" />
            </a>
            <div class="clear"></div>
          </li>
          <li class="tips">
            <span class="fl">京公网安备 11010102002958号</span>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102002958"
              target="_blank"
              class="fl"
            >
              <img src="http://www.drcnet.com.cn/www/int/images/biaoshi.gif" />
            </a>
            <div class="clear"></div>
          </li>
          <li class="tips" style="float:right;">
            <span>建议浏览器：IE9+、火狐、谷歌</span>
            <div class="clear"></div>
          </li>
        </ul>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data(){
    return{
      newYear: new Date().getFullYear()
    }
  }
};
</script>

<style scoped>
.ipc{color:#797b80;width: 110px;display: inline-block;}
.ipc:hover{font-weight: 700}
.footer{ color:#fff; background:#2c303b; height:270px;padding-top:40px; margin-top:50px;}
.menu1{ color:#525e6d}
.menu1 a{padding:0 10px; color:#fff}
.right_f{  text-align:center;width:122px;}
.right_f img{width:110px;margin: 0 auto;}
.right_f p{ font-size:12px; color:#797b80; padding-top:10px;}
.bottom-f{ color:#797b80;height:45px; line-height:45px; margin-top: 30px; }
.bottom-f .bq li{ float:left;}
.bottom-f .bq li span{color:#797b80; font-size:13px;}
.bottom-f img{padding-left: 7px; padding-top:12px; padding-right:28px;}
.tel { width:240px; padding-top:50px;}
.tel img{ padding-right:15px;}
.tel .hm p,.hm span,.footer_bottom{color:#797b80;}
.tel .hm p{  font-size:22px;}
.footer_bottom{ padding-top:20px; font-size:14px;}
.dtgif{ position:relative; left:-50px;display:none;}
.ewm li{ float: left;}
.ewm li img{ width: 100px; height: 100px; margin:0 5px}
.menu a{ font-size: 15px;}
.footer{padding-top: 35px;}
.right_f_wx {width: 445px;margin-top: 20px;text-align: center;}
.right_f_wx p{ font-size: 13px;color: #797b80;padding-top: 10px;}
</style>
